import requestData from "./requestData";

class categoryService {
    getCategory = () => requestData("GET", '/api/items/categories')
    getItems = (slug) => requestData("GET", `/api/items?category_slug=${slug}`,)
}

export default new categoryService();